import React from "react";
import { Link } from "react-router-dom";
import "./StaticPages.css";

const NotFound = () => {
  return (
    <section className="static-page-section">
      <div className="auto-container">
        <div className="static-hero">
          <div className="not-found-code">404</div>
          <h1>Page Not Found</h1>
          <p>The page you are looking for does not exist or may have been moved.</p>
          <div className="static-actions">
            <Link to="/" className="theme-btn btn-style-one">Go Home</Link>
            <Link to="/jobs" className="theme-btn btn-style-three">Browse Jobs</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
